<template>
  <section class="w-full max-w-7xl mx-auto [@media(max-width:1280px)]:px-[60px] py-[60px] grid gap-18 grid-cols-1 lg:grid-cols-[55%_1fr]">
    <div class="w-full overflow-hidden">
      <div class="transitionStyle flex gap-2" :style="{ transform: `translateX(-${currentIndex * 65}%)` }">
        <div
          v-for="(testimonial, index) in testimonials"
          :key="index"
          :style="{
            flex: '0 0 70%',
          }"
          class="bg-white p-[28px] shadow-[2px_2px_20px_4px_rgba(203,210,216,0.18)]"
        >
          <div class="flex">
            <img class="w-[40px] h-[40px] mr-[15px]" :src="testimonial.avatar" alt="avatar" />
            <div>
              <div class="gap-[2px] flex">
                <span class="text-[#E47676] text-[28px]" v-for="i in 5" :key="i">★</span>
              </div>
              <div class="text-[16px] text-[#656568]">
                {{ testimonial.username }}
              </div>
            </div>
          </div>
          <h3 class="text-[28px] mt-[16px] font-bold">
            {{ testimonial.headline }}
          </h3>
          <p class="text-[16px] mt-[16px] text-[#1D1D1F]">
            {{ testimonial.review }}
          </p>
        </div>
      </div>

      <!-- 导航按钮 -->
      <div class="flex justify-end gap-[16px] mt-[30px]">
        <button class="nav-btn" @click="prevSlide" :disabled="currentIndex === 0">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48" height="48" aria-hidden="true">
            <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="1" class="circle" />
            <path
              class="arrow"
              d="M16 12H8M12 8l-4 4 4 4"
              fill="none"
              stroke="currentColor"
              stroke-width="1"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <button class="nav-btn" @click="nextSlide" :disabled="currentIndex >= maxIndex">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48" height="48" aria-hidden="true">
            <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="1" class="circle" />
            <path
              class="arrow"
              d="M8 12h8M12 8l4 4-4 4"
              fill="none"
              stroke="currentColor"
              stroke-width="1"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>

    <div class="mt-[0px]">
      <div class="text-[24px] font-semibold">Where Women Grow Together in God’s Word</div>
      <p class="text-[18px] mt-[8px] text-[#47201A]">
        It’s a space where faith feels alive and shared — where women uplift one another with Scripture, prayer, and real understanding. Whether
        you’re celebrating blessings or walking through storms, you’ll always find a sister ready to pray beside you.
      </p>

      <div class="flex w-full justify-between">
        <div class="text-center">
          <div class="text-[24px] text-[#6155FF] font-bold mt-[40px]">100<span class="text-[#6155FF]">+</span></div>
          <div class="text-[18px] text-[#47201A] mt-[16px]">Churches recommend it</div>
        </div>
        <div>
          <div class="text-[24px] text-[#2D968C] font-bold mt-[40px]">20,000<span class="text-[#2D968C]">+</span></div>
          <div class="text-[18px] text-[#47201A] mt-[16px]">Likes from believers</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue'
import avatar1 from '@/assets/imgs/pageComment/avatar1.png'
import avatar2 from '@/assets/imgs/pageComment/avatar2.png'
import avatar3 from '@/assets/imgs/pageComment/avatar3.png'

// 用户评价数据
const testimonials = ref([
  {
    avatar: avatar1,
    username: 'GracefulMom85',
    headline: 'A Beautiful Blessing in My Daily Routine',
    review: `This app has become part of my morning and evening prayers. The devotionals speak straight to my heart, and the prayers feel like they were written just for me. I’ve never felt so consistent and peaceful in my quiet time before.`,
  },
  {
    avatar: avatar2,
    username: 'FaithJourney22',
    headline: 'Finally, a Bible App for Women Like Me!',
    review:
      'I love the Assist section — it’s so comforting to know that when I post a prayer request, real sisters in Christ reply with love and scripture. It’s more than an app; it’s a faith family.',
  },
  {
    avatar: avatar3,
    username: 'JoyfulHeart',
    headline: 'Fun Way to Learn the Bible',
    review:
      'The Bible quizzes are my favorite part! I’ve learned so much and even shared it with my small group. It’s great to see an app that mixes joy, community, and Scripture so beautifully.',
  },
])

// 轮播状态
const currentIndex = ref(0)
const maxIndex = computed(() => Math.max(0, testimonials.value.length - 1))

// 轮播控制函数
const nextSlide = () => {
  if (currentIndex.value < maxIndex.value) {
    currentIndex.value++
  }
}

const prevSlide = () => {
  if (currentIndex.value > 0) {
    currentIndex.value--
  }
}

// 自动轮播
let autoPlayInterval: number | null = null

const startAutoPlay = () => {
  autoPlayInterval = setInterval(() => {
    if (currentIndex.value >= maxIndex.value) {
      currentIndex.value = 0
    } else {
      currentIndex.value++
    }
  }, 5000)
}

const stopAutoPlay = () => {
  if (autoPlayInterval) {
    clearInterval(autoPlayInterval)
    autoPlayInterval = null
  }
}

// 组件挂载时开始自动轮播
onMounted(() => {
  startAutoPlay()
})

onUnmounted(() => {
  stopAutoPlay()
})
</script>

<style lang="less" scoped>
.transitionStyle {
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}
.nav-btn {
  &:hover:not(:disabled) .circle {
    fill: black;
  }
  &:hover:not(:disabled) .arrow {
    stroke: white;
  }
  &:disabled .circle {
    fill: #f5f5f5;
    stroke: #eeeeee;
  }
  &:disabled .arrow {
    stroke: #cccccc;
  }
}
</style>
